const attachmentTypes = {
    CASE: 0,
    DRAFT: 1,
    UPLOAD: 2,
};

export default attachmentTypes;
